import {
    AppsListDetail20Filled,
    ChevronDownRegular,
} from "@fluentui/react-icons";
import {
    Accordion,
    AddIcon,
    Avatar,
    Flex,
    Text,
} from "@fluentui/react-northstar";
import moment from "moment";
import React, { useState } from "react";
import styled from "styled-components";

export const HistoriqueArchivedCollab = ({ ArchivedUser }) => {
    const [openAccordionIndexs, setOpenAccordionIndexs] = useState([]);

    const toggleAccordion = (index) => {
        if (openAccordionIndexs.includes(index)) {
            setOpenAccordionIndexs(
                openAccordionIndexs.filter((item) => item !== index)
            );
        } else {
            setOpenAccordionIndexs([...openAccordionIndexs, index]);
        }
        return;
    };

    const dayFormated = (date) => {
        return moment(date).format("DD/MM/YYYY");
    };

    return (
        <HistoricContent column fill>
            <HistoriqueHeader vAlign="center" gap={"gap.small"} fill>
                <AppsListDetail20Filled />
                <HeaderText content="Historique du collaborateur" />
            </HistoriqueHeader>
            <MainContent column fill>
                {ArchivedUser?.history?.map((history, index) => {
                    const expendAccordion = openAccordionIndexs.includes(index);
                    const extraData = history?.extra_data;
                    const lenExtraData = extraData.length;
                    return (
                        <Flex
                            key={index}
                            styles={{ gap: "16px", padding: "0px 32px" }}
                            column
                        >
                            <DateFlex>
                                <DateText content={dayFormated(history.date)} />
                            </DateFlex>
                            <HistoricCard vAlign="center" space="between">
                                <Flex
                                    column
                                    vAlign="center"
                                    gap={"gap.small"}
                                    fill
                                >
                                    <Flex fill>
                                        <Flex fill gap="gap.medium">
                                            <div style={{ width: "32px" }}>
                                                <Avatar
                                                    image={
                                                        history?.processed_by_avatar
                                                    }
                                                    name={
                                                        history?.processed_by_name
                                                    }
                                                />
                                            </div>
                                            <Flex column>
                                                <Flex column>
                                                    <TitleCard
                                                        content={
                                                            history.status_text
                                                        }
                                                    />
                                                    <DescribtionCard
                                                        content={
                                                            history.status_description
                                                        }
                                                    />
                                                </Flex>
                                                {expendAccordion &&
                                                    lenExtraData > 0 && (
                                                        <Flex
                                                            styles={{
                                                                paddingTop:
                                                                    "16px",
                                                                gap: "16px",
                                                            }}
                                                            column
                                                        >
                                                            <Flex
                                                                styles={{
                                                                    gap: "4px",
                                                                }}
                                                                column
                                                            >
                                                                {extraData?.map(
                                                                    (data) => {
                                                                        console.log(
                                                                            {
                                                                                data195:
                                                                                    data,
                                                                                extraData,
                                                                            }
                                                                        );
                                                                        return (
                                                                            <Flex
                                                                                column
                                                                            >
                                                                                {data?.label &&
                                                                                    data?.value && (
                                                                                        <AccordionTitle
                                                                                            content={
                                                                                                data?.label
                                                                                            }
                                                                                        />
                                                                                    )}
                                                                                {data?.value && (
                                                                                    <AccordionDescription
                                                                                        content={
                                                                                            data?.value
                                                                                        }
                                                                                    />
                                                                                )}
                                                                            </Flex>
                                                                        );
                                                                    }
                                                                )}
                                                            </Flex>
                                                        </Flex>
                                                    )}
                                            </Flex>
                                        </Flex>
                                        {lenExtraData > 0 && (
                                            <ChevronDownRegular
                                                onClick={() =>
                                                    toggleAccordion(index)
                                                }
                                                style={{
                                                    cursor: "pointer",
                                                    transform: expendAccordion
                                                        ? "rotate(180deg)"
                                                        : "rotate(0deg)",
                                                }}
                                            />
                                        )}
                                    </Flex>
                                </Flex>
                            </HistoricCard>
                        </Flex>
                    );
                })}
            </MainContent>
        </HistoricContent>
    );
};

const AccordionDescription = styled(Text)`
    color: #242424;
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 12px;
`;

const AccordionTitle = styled(Text)`
    color: #616161;
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 12px;
`;

const MainContent = styled(Flex)`
    overflow-y: scroll;
    padding-bottom: 24px;
`;

const HistoricCard = styled(Flex)`
    border-radius: 4px;
    padding: 12px 16px;
    background: #fff;
    box-shadow: 0px 0.6px 1.8px 0px rgba(0, 0, 0, 0.11),
        0px 3.2px 7.2px 0px rgba(0, 0, 0, 0.13);
    width: 326px;
`;

const DateText = styled(Text)`
    color: black;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 16px;
`;

const DateFlex = styled(Flex)`
    background: #e8ebfa;
    border-radius: 4px;
    width: fit-content;
    padding: 4px 8px;
    margin-top: 24px;
`;

const HistoriqueHeader = styled(Flex)`
    border-radius: 8px 8px 0px 0px;
    background: #e8ebfa;
    /* width: 418px; */
    height: 48px;
    padding: 12px 20px;
    position: sticky;
    top: 0;
`;

const HeaderText = styled(Text)`
    color: #424242;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
`;

const HistoricContent = styled(Flex)`
    background-color: white;
    /* gap: 24px; */
    height: 421px;
    /* overflow-y: scroll; */
    padding-bottom: 16px;
    border-radius: 8px;
    background: var(--Light-theme-Rest-Background-Default-Background, #fff);

    /* shadow-4 */
    box-shadow: 0px 0.3px 0.9px 0px rgba(0, 0, 0, 0.07),
        0px 1.6px 3.6px 0px rgba(0, 0, 0, 0.11);
`;

const TitleCard = styled(Text)`
    color: #242424;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 16px;
`;

const DescribtionCard = styled(Text)`
    color: #242424;
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 12px;
`;
